import React from 'react';
import { PropTypes, describe } from 'react-desc';

var DSError = function DSError(_ref) {
  var _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$errorText = _ref.errorText,
      errorText = _ref$errorText === void 0 ? 'Error' : _ref$errorText;
  if (!hasError) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "em-ds-error"
  }, errorText);
};

var props = {
  /** error state */
  hasError: PropTypes.bool.description('error state'),

  /** error label text */
  errorText: PropTypes.string.description('error label text')
};
DSError.propTypes = props;
var DSErrorWithSchema = describe(DSError);
DSErrorWithSchema.propTypes = props;

export default DSError;
export { DSErrorWithSchema };
//# sourceMappingURL=DSError.js.map
